import { Menu, MenuItem, Box, Typography, Divider } from "@mui/material";
import DomainLinks from "@/modules/common/components/layout/side-menu/components/domain-links";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import ToggleButton from "@/modules/common/components/input/toggle-button";
import { useNavigate } from "react-router-dom";

const menuStyles = {
  minWidth: 240,
  fontSize: 14,
  lineHeight: "20px",
  typography: nawyTheme.nawy.typography.english.variants.body.md.regular,
};

export const UserMenuDropdown = ({
  anchorEl,
  onClose,
  isFranchise,
  userTiers,
  isAvailable,
  isAutodialerActive = false,
  toggleUserAvailability,
  logout,
}: {
  anchorEl: null | HTMLElement;
  onClose: () => void;
  isFranchise: string;
  userTiers?: string[];
  isAvailable: boolean;
  isAutodialerActive?: boolean;
  toggleUserAvailability: (val: boolean) => void;
  logout: () => void;
}) => {
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isAutodialerActive) return;
    toggleUserAvailability(e.target.checked);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { padding: 0, minWidth: menuStyles.minWidth } }}
    >
      {isFranchise === "true" && (
        <MenuItem
          onClick={() => {
            onClose();
            navigate("/reset-password");
          }}
          sx={{ justifyContent: "center" }}
        >
          Change password
        </MenuItem>
      )}

      <DomainLinks userTiers={userTiers} />

      <Divider />

      <Box
        sx={{
          padding: 2,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography sx={{ ...menuStyles.typography }}>Available</Typography>

          <Box display="flex" alignItems="center" gap={1}>
            {isAutodialerActive && (
              <Box
                sx={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 1,
                  color: "#015C9A",
                  border: "1px solid #015C9A",
                  lineHeight: "16px",
                }}
              >
                Autodialer
              </Box>
            )}
            <ToggleButton
              checked={isAvailable || isAutodialerActive}
              onChange={handleToggle}
              disabled={isAutodialerActive}
              size="small"
              data-testid="availability-switch"
            />
          </Box>
        </Box>

        {isAutodialerActive && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ marginLeft: "auto" }}
          >
            Can't change availability while Autodialer is connected
          </Typography>
        )}
      </Box>

      <Divider />

      <MenuItem
        onClick={() => {
          onClose();
          logout();
        }}
        sx={{ ...menuStyles, color: "#C72D22" }}
      >
        Log out
      </MenuItem>
    </Menu>
  );
};
